import React from 'react';
import { inject, observer } from "mobx-react";
import ym from 'react-yandex-metrika';
import Input from '../../../ui/input';
import {
  logForLostFocusEmail,
} from "../../../../logger/loggerRegForm";

const EmailInput = inject('kafkaStore')(observer((props) => {
  const { onInput,
    value,
    errorMessage,
    label,
    kafkaStore: {
      imprintHash
    },
  } = props;

  const logBlurInput = (value, imprint) => {
    logForLostFocusEmail(value, imprint)
  }

  const onBlurInput = () => {
    logBlurInput(value, imprintHash);
    ym('reachGoal','regType')
  }

  return (
    <Input
      onBlur={onBlurInput}
      className='Email'
      label={label}
      type='Email'
      value={value}
      onInput={onInput}
      error={errorMessage}
    />
  );
}));

export default EmailInput;